// extracted by mini-css-extract-plugin
export default {"container":"_3lWYCO3AbhqxqFoRbPbP8y","text":"_7YYJMESDqfQ34dcWMqwbP"};